// breakpoint values according to the UW data-grid positioning
export enum Position {
  RightTop = 1,
  RightMiddle = 2,
  RightBottom = 3,
  MiddleBottom = 4,
  LeftBottom = 5,
  LeftMiddle = 6,
  LeftTop = 7,
  MiddleTop = 8,
}

export enum AbsolutePosition {
  Left = 'left',
  Right = 'right',
}

export const positionState = (state: number) => {
  switch (state) {
    case Position.MiddleTop:
      return Position.LeftTop;
    case Position.MiddleBottom:
      return Position.RightBottom;
    default:
      return state;
  }
};

export const getAbsolutePosition = (state: number) =>
  state <= Position.MiddleBottom
    ? AbsolutePosition.Right
    : AbsolutePosition.Left;
